import { Grid } from '@mui/material';
import { useField } from 'react-final-form';

import { TextField } from '@occc-app/design-system';
import { isFloat } from '@occc-app/routes/Location/utils';
import { LocationAddressGeolocationCardMap } from '../../retailer-network-location-details-page/components/location-address-geolocation-card';

import { LocationAddressGeolocation } from '../retailer-network-location-update-page.types';

type StoreLocationProps = {
  geoLocation: LocationAddressGeolocation | null;
  hasAddress: boolean;
};

export const StoreLocation = ({ geoLocation, hasAddress }: StoreLocationProps) => {
  const scheduleField = useField('geoLocation');
  const geolocation = {
    latitude: Number(geoLocation?.latitude) || 0,
    longitude: Number(geoLocation?.longitude) || 0,
  };

  const onMarkerDrag = (coords: LocationAddressGeolocation) => {
    scheduleField.input.onChange(coords);
  };

  return (
    <Grid container spacing={3} alignItems='flex-start'>
      <Grid item xs={12} md={3}>
        <TextField
          sx={{ m: 0 }}
          name='geoLocation.latitude'
          label='Latitude'
          fieldProps={{
            validate: isFloat,
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          sx={{ m: 0 }}
          name='geoLocation.longitude'
          label='Longitude'
          fieldProps={{
            validate: isFloat,
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          '&.MuiGrid-item': {
            xs: { display: 'flex', pt: 0, alignContent: 'flex-end', marginTop: 3 },
            md: { marginTop: 'unset' },
          },
        }}
      >
        <LocationAddressGeolocationCardMap
          geolocation={geolocation}
          hasAddress={hasAddress}
          onMarkerDrag={onMarkerDrag}
        />
      </Grid>
    </Grid>
  );
};
